import React, { useMemo, useRef } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import { Select } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import ExpandMore from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      marginRight: 0,
    },
    "& fieldset": {
      borderColor: theme.palette.primary.main,
      borderWidth: "2px",
    },
  },
  styledSelect: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    borderWidth: "2px",
    "& select.MuiSelect-select": {
      minWidth: theme.spacing(3),
      padding: theme.spacing(2, 3, 2, 2),
      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(1, 1), // reduced padding on mobile
        textAlign: "center",
      },
    },
    "& .MuiSelect-icon": {
      color: "inherit",
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
  },
  disabled: {
    borderColor: theme.palette.primary.light,
  },
}));

export default ({
  id,
  quantity,
  minQuantity,
  includeZero,
  onChange,
  maxQuantity,
  disabled,
}) => {
  const classes = useStyles();

  const quantityList = useMemo(() => {
    // There have to be a better way to make this?
    const options = [];
    const maxVal = maxQuantity || quantity + 100;
    console.log("Max val is", minQuantity, maxVal);
    for (let i = minQuantity || 1; i <= maxVal; i++) {
      options.push(i);
    }
    console.log("Max val", options);
    return options;
  }, [quantity, maxQuantity, minQuantity]);

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <Select
        native
        value={quantity}
        onChange={onChange}
        id={id}
        disabled={disabled}
        className={`${classes.styledSelect}`}
        IconComponent={ExpandMore}
      >
        {includeZero && <option value={0}>0</option>}
        {quantityList.map((i) => (
          <option key={i} value={i}>
            {i}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};
